<div [attr.id]="id ? id + '-spinner-container' : 'global-progress-spinner'" class="spinner-container">
  <app-ellipsis-loading [id]="id"></app-ellipsis-loading>
  <span [attr.id]="id ? id + '-spinner-text' : null" class="text" i18n="@@PleaseWait">Espere mientras se carga la informacion</span>
</div>
